import { useEffect, useRef, useState } from "react";
import MenuSistema from "../components/menu_sistema";
import { Button, Card, Container, Dimmer, Dropdown, Form, Header, Icon, Loader, Menu, Modal, Pagination, Segment, Table, Label, Message } from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import axios from "axios";
import {
  URL_AGENCIADOR,
  URL_COMISSOES,
  URL_FILIAL,
  URL_RCA,
  URL_STATUS_FATURA,
  URL_DADOS_VENDA,
  URL_DADOS_VENDA_LOTE,
  URL_APROVAR_COMERCIAL,
  URL_APROVAR_FINANCEIRO,
  URL_ORIGENS_DESDOBRAMENTO,
  URL_EXPANDIR_CHAVES_DESDOBRAMENTO,
  URL_REJEITAR,
  URL_CONSULTAR_STATUS_PGCOM,
  URL_OBTER_RELACIONAMENTO_EMLOTE,
  URL_CONSULTAR_STATUS_APRO,
  URL_CONSULTAR_LOTE,
  URL_USUARIO,
  URL_APROVADO_POR,
  URL_STATUS_PENDENTE,
} from "../main/api_calls";
import Util from "../main/util";
import RelatorioPdfGestao from "./relatorio_pdf_gestao";
import { pdf } from "@react-pdf/renderer";
import AuthenticationService from "../main/AuthenticationService";
import { useNavigate } from "react-router-dom";
import { CHAVE_WINTHOR_SERVICE } from "../constantes";

const selectPgCom = [
  { key: "1", value: "", text: "Selecione" },
  { key: "2", value: "Em Aberto", text: "Em Aberto" },
  { key: "3", value: "Pago", text: "Pago" },
  { key: "4", value: "Parcialmente Pago", text: "Parcialmente Pago" },
];
const selectStatusApro = [
  { key: "1", value: "", text: "Selecione" },
  { key: "2", value: "Aprovada", text: "Aprovada" },
  { key: "3", value: "Pendente", text: "Pendente" },
  { key: "4", value: "Rejeitada", text: "Rejeitada" },
];
const qtdItensLista = [
  { value: "10", text: "10 itens por pagina", key: "10" },
  { value: "25", text: "25 itens por pagina", key: "25" },
  { value: "50", text: "50 itens por pagina", key: "50" },
  { value: "100", text: "100 itens por pagina", key: "100" },
  // { value: '100000', text: 'Exibir Todos os Itens', key: "100000" },
];
const LIMITE_CONFIRMACAO_GESTAO = 1000;

export default function ControleComissoes() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState({});
  const [menuFiltro, setMenuFiltro] = useState(true);

  const [listaFiliais, setListaFiliais] = useState([]);
  const [listaAgenciadores, setListaAgenciadores] = useState([]);
  const [listaRCA, setListaRCA] = useState([]);
  const [listaFaturas, setListaFaturas] = useState([]);
  const [listaStatusFatura, setListaStatusFatura] = useState([]);
  const [listaAprovadores, setListaAprovadores] = useState([]);
  const [listaComissoesSelecionadas, setListaComissoesSelecionadas] = useState([]);

  const [faturaModal, setFaturaModal] = useState(null);
  const [openModalAprovacao, setOpenModalAprovacao] = useState(false);
  const [openModalRejeicao, setOpenModalRejeicao] = useState(false);
  const [openModalAprovacaoMultipla, setOpenModalAprovacaoMultipla] = useState(false);
  const [openModalRejeicaoMultipla, setOpenModalRejeicaoMultipla] = useState(false);

  const [filtroFilial, setFiltroFilial] = useState([]);
  const [filtroRca, setFiltroRca] = useState([]);
  const [filtroAgenciador, setFiltroAgenciador] = useState([]);
  const [filtroNota, setFiltroNota] = useState("");
  const [filtroTransacao, setFiltroTransacao] = useState("");
  const [filtroStatusFatura, setFiltroStatusFatura] = useState("");
  const [filtroPgCom, setFiltroPgCom] = useState("");
  const [filtroEmissaoInicial, setFiltroEmissaoInicial] = useState("");
  const [filtroEmissaoFinal, setFiltroEmissaoFinal] = useState("");
  const [filtroStatusAprovacao, setFiltroStatusAprovacao] = useState("");
  const [filtroAprovadoPor, setFiltroAprovadoPor] = useState("");
  const [textoAtalhoPeriodo, setTextoAtalhoPeriodo] = useState('Atalhos de Período');

  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [sizeItensLista, setSizeItensLista] = useState("10");
  const [totalRegistros, setTotalRegistros] = useState("");
  const [totalComissaoBruta, setTotalComissaoBruta] = useState(0);

  const [loadingCard, setLoadingCard] = useState(false);
  const [statusConsulta, setStatusConsulta] = useState("idle");
  const [confirmacaoVolume, setConfirmacaoVolume] = useState({ open: false, total: 0, assinatura: "", pagina: 1, tamanho: "10" });
  const assinaturaVolumeConfirmadaRef = useRef("");
  const [loadingModal, setLoadingModal] = useState(false);
  const [habilitarPdf, setHabilitarPdf] = useState(false);
  const [progressoLoading, setProgressoLoading] = useState(0);

  useEffect(() => {
    assinaturaVolumeConfirmadaRef.current = "";
  }, [
    filtroFilial,
    filtroRca,
    filtroAgenciador,
    filtroNota,
    filtroTransacao,
    filtroStatusFatura,
    filtroEmissaoInicial,
    filtroEmissaoFinal,
    filtroPgCom,
    filtroStatusAprovacao,
    filtroAprovadoPor,
  ]);

  useEffect(() => {
    let intervalId;
    if (loadingCard) {
      setProgressoLoading(1);
      intervalId = setInterval(() => {
        setProgressoLoading((prev) => {
          if (prev >= 99) return 99;
          const next = prev + Math.floor(Math.random() * 5) + 1;
          return next > 99 ? 99 : next;
        });
      }, 150);
    } else {
      setProgressoLoading(100);
      const timeoutId = setTimeout(() => setProgressoLoading(0), 300);
      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }
    return () => clearInterval(intervalId);
  }, [loadingCard]);

  const [formMotivoRejeicao, setFormMotivoRejeicao] = useState("");
  const [formEmailsAprovacao, setFormEmailsAprovacao] = useState("");

  useEffect(() => {
    sessionStorage.setItem("nReq", 0);
    if (AuthenticationService.isUserLoggedIn()) {
      let usuario = AuthenticationService.getUsuario();
      if (usuario.perfil === "Comercial" || usuario.perfil === "Financeiro" || usuario.perfil === "Admin") {
        setUsuario(usuario);
        let formData = new FormData();
        formData.append("chave", CHAVE_WINTHOR_SERVICE);
        axios
          .post(URL_FILIAL, formData)
          .then((response) => {
            carregarListaFilial(response.data);
          })
          .catch((error) => {
            Util.tratarErro(error);
          });

        axios
          .post(URL_AGENCIADOR, formData)
          .then((response) => {
            carregarListaAgenciador(response.data);
          })
          .catch((error) => {
            Util.tratarErro(error);
          });

        axios
          .post(URL_RCA, formData)
          .then((response) => {
            carregarListaRCA(response.data);
          })
          .catch((error) => {
            Util.tratarErro(error);
          });

        axios
          .post(URL_STATUS_FATURA, formData)
          .then((response) => {
            carregarListaStatusFatura(response.data);
          })
          .catch((error) => {
            Util.tratarErro(error);
          });

        axios
          .get(URL_USUARIO)
          .then((response) => {
            carregarListaAprovadores(response.data.filter((user) => user.roles[0] === "Comercial" || user.roles[0] === "Financeiro"));
          })
          .catch((error) => {
            Util.tratarErro(error);
          });
      } else {
        navigate("/consulta-vendas-agenciadas");
      }
    } else {
      AuthenticationService.logout();
    }
  }, []);

  function carregarListaFilial(filiais) {
    let listaF = [];
    filiais.forEach((filial) => {
      let f = {
        key: filial.codigo,
        value: filial.codigo,
        text: filial.razaoSocial,  // .replace(/ - .+$/, ''),  // + " - " + filial.cidade    // Remove a cidade do final da razao social, caso ja esteja mesclada no formato "Nome - Cidade"
      };
      listaF.push(f);
    });
    setListaFiliais(listaF);
  }

  function carregarListaAgenciador(agenciadores) {
    let listaA = [];
    agenciadores.forEach((a) => {
      let agenciador = {
        key: a.codusur,
        value: a.codusur,
        text: a.codusur + " - " + a.nome,
      };
      listaA.push(agenciador);
    });
    setListaAgenciadores(listaA);
  }

  function carregarListaRCA(rcas) {
    let listaR = [];
    rcas.forEach((r) => {
      let rca = {
        key: r.codusur,
        value: r.codusur,
        text: r.codusur + " - " + r.nome,
      };
      listaR.push(rca);
    });
    setListaRCA(listaR);
  }

  function carregarListaStatusFatura(ObjetoStatusFatura) {
    let listaStatusFatura = Object.values(ObjetoStatusFatura);
    let listaSF = [];
    let statusFatura = {
      key: "n",
      value: "",
      text: "Selecione",
    };
    listaSF.push(statusFatura);
    for (let i = 0; i < listaStatusFatura.length; i++) {
      statusFatura = {
        key: i,
        value: listaStatusFatura[i],
        text: listaStatusFatura[i],
      };
      listaSF.push(statusFatura);
    }
    setListaStatusFatura(listaSF);
  }

  function carregarListaAprovadores(users) {
    let listaU = [];
    let selecione = { key: "n", value: "", text: "Selecione" };
    listaU.push(selecione);
    users.forEach((u) => {
      let user = {
        key: u.id,
        value: u.nome,
        text: u.nome + " - " + u.roles[0],
      };
      listaU.push(user);
    });
    setListaAprovadores(listaU);
  }
  function aplicarPeriodoRapido(periodo) {
    if (!periodo) return;
    
    const hoje = new Date();
    let dataIni = new Date();
    let dataFim = new Date();

    let texto = 'Atalhos de Período';

    if (periodo === "semana") {
      const diaSemana = hoje.getDay(); 
      const diffSegunda = hoje.getDate() - diaSemana + (diaSemana === 0 ? -6 : 1); 
      dataIni = new Date(hoje.setDate(diffSegunda));
      dataFim = new Date(dataIni);
      dataFim.setDate(dataIni.getDate() + 6);
      texto = 'Esta Semana';
    } else if (periodo === "mes") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      dataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      texto = 'Este Mês';
    } else if (periodo === "mes_passado") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
      dataFim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
      texto = 'Mês Passado';
    } else if (periodo === "3_meses") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 3, hoje.getDate());
      dataFim = new Date();
      texto = 'Últimos 3 Meses';
    } else if (periodo === "6_meses") {
      dataIni = new Date(hoje.getFullYear(), hoje.getMonth() - 6, hoje.getDate());
      dataFim = new Date();
      texto = 'Últimos 6 Meses';
    } else if (periodo === "1_ano") {
      dataIni = new Date(hoje.getFullYear() - 1, hoje.getMonth(), hoje.getDate());
      dataFim = new Date();
      texto = 'Último 1 Ano';
    } else if (periodo === "hoje") {
      dataIni = new Date();
      dataFim = new Date();
      texto = 'Hoje';
    }

    setFiltroEmissaoInicial(dataIni);
    setFiltroEmissaoFinal(dataFim);
    setTextoAtalhoPeriodo(texto);
  }

  async function expandirChavesDesdobradas(chaves) {
    if (!chaves || chaves.length === 0) return [];

    const payload = chaves.map(chave => {
      const partes = chave.split("-");
      return { numeroTransacaoVenda: partes[0], prestacao: partes[1] };
    });
    const response = await axios.post(
      URL_EXPANDIR_CHAVES_DESDOBRAMENTO + "?chave=" + CHAVE_WINTHOR_SERVICE,
      payload
    );

    return [...new Set(response.data.map(
      item => item.numeroTransacaoVenda + "-" + item.prestacao
    ))];
  }

  function dataSemHora(data) {
    if (!data) return null;
    const dataObj = data instanceof Date ? data : new Date(`${data}T00:00:00`);
    if (Number.isNaN(dataObj.getTime())) return null;
    return new Date(dataObj.getFullYear(), dataObj.getMonth(), dataObj.getDate()).getTime();
  }

  function obterAssinaturaFiltros() {
    return JSON.stringify({
      filial: filtroFilial,
      rca: filtroRca,
      agenciador: filtroAgenciador,
      nota: String(filtroNota || "").trim(),
      transacao: String(filtroTransacao || "").trim(),
      statusFatura: filtroStatusFatura,
      dataInicial: dataSemHora(filtroEmissaoInicial),
      dataFinal: dataSemHora(filtroEmissaoFinal),
      pgCom: filtroPgCom,
      statusAprovacao: filtroStatusAprovacao,
      aprovadoPor: filtroAprovadoPor,
    });
  }

  function validarFiltrosPesquisa(exibirMensagem = false) {
    const temNota = filtroNota && String(filtroNota).trim().length > 0;
    const temAgenciador = filtroAgenciador && filtroAgenciador.length > 0;
    const temRca = filtroRca && filtroRca.length > 0;
    const temDataInicial = Boolean(filtroEmissaoInicial);
    const temDataFinal = Boolean(filtroEmissaoFinal);
    const temPeriodoCompleto = temDataInicial && temDataFinal;

    if (temDataInicial !== temDataFinal) {
      if (exibirMensagem) {
        Util.notifyImportant("Informe as datas de emissão inicial e final para pesquisar por período.");
      }
      return false;
    }
    if (temPeriodoCompleto && dataSemHora(filtroEmissaoInicial) > dataSemHora(filtroEmissaoFinal)) {
      if (exibirMensagem) {
        Util.notifyImportant("A Data de Emissão Inicial não pode ser posterior à Data de Emissão Final.");
      }
      return false;
    }
    if (!temPeriodoCompleto && !temNota && !temAgenciador && !temRca) {
      if (exibirMensagem) {
        Util.notifyImportant("Informe o período completo, o Número da Nota, um RCA ou um Agenciador.");
      }
      return false;
    }
    return true;
  }

  function limparResultadosPesquisa() {
    setListaComissoesSelecionadas([]);
    setListaFaturas([]);
    setTotalPages(0);
    setTotalRegistros(0);
    setTotalComissaoBruta(0);
    setHabilitarPdf(false);
  }

  function filtrarComissoes(isManual = false, paginaSolicitada = activePage, tamanhoSolicitado = sizeItensLista) {
    if (!validarFiltrosPesquisa(isManual)) {
      if (isManual) {
        setStatusConsulta("idle");
        limparResultadosPesquisa();
      }
      return;
    }
    const assinaturaPesquisa = obterAssinaturaFiltros();

    setLoadingCard(true);
    setStatusConsulta("loading");
    limparResultadosPesquisa();
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    let nReqAtual = sessionStorage.getItem("nReq");

    let formData = new FormData();
    formData.append("chave", CHAVE_WINTHOR_SERVICE);
    if (filtroFilial.length > 0) formData.append("filiais", filtroFilial.join(","));
    if (filtroRca.length > 0) formData.append("rca", filtroRca.join(","));
    if (filtroAgenciador.length > 0) formData.append("idsAgenciador", filtroAgenciador.map(id => "'" + id + "'").join(","));
    if (filtroNota) formData.append("numeroNota", filtroNota);
    if (verificarTransacaoValida(filtroTransacao)) {
      formData.append("numeroTransacao", filtroTransacao);
    }
    if (filtroStatusFatura) formData.append("statusFatura", filtroStatusFatura);

    const formatarParaEnvio = (val) => {
      if (!val) return "";
      if (val instanceof Date) {
        const mes = String(val.getMonth() + 1).padStart(2, "0");
        const dia = String(val.getDate()).padStart(2, "0");
        return `${dia}/${mes}/${val.getFullYear()}`;
      }
      const parsed = new Date(val + "T00:00:00");
      if (Number.isNaN(parsed.getTime())) return String(val);
      const mes = String(parsed.getMonth() + 1).padStart(2, "0");
      const dia = String(parsed.getDate()).padStart(2, "0");
      return `${dia}/${mes}/${parsed.getFullYear()}`;
    };

    if (filtroEmissaoInicial && filtroEmissaoFinal) {
      formData.append("dataEmissaoInicial", formatarParaEnvio(filtroEmissaoInicial));
      formData.append("dataEmissaoFinal", formatarParaEnvio(filtroEmissaoFinal));
    } else if (filtroEmissaoInicial) {
      formData.append("dataEmissaoInicial", formatarParaEnvio(filtroEmissaoInicial));
    } else if (filtroEmissaoFinal) {
      formData.append("dataEmissaoFinal", formatarParaEnvio(filtroEmissaoFinal));
    }
    formData.append("size", tamanhoSolicitado);
    formData.append("page", paginaSolicitada);

    const executarBuscaWinthor = async () => {
      axios
        .post(URL_COMISSOES, formData)
        .then(async (response) => {
          if (nReqAtual === sessionStorage.getItem("nReq")) {
            const totalEncontrado = Number(response.data.totalElements || 0);
            if (totalEncontrado > LIMITE_CONFIRMACAO_GESTAO && assinaturaVolumeConfirmadaRef.current !== assinaturaPesquisa) {
              setConfirmacaoVolume({
                open: true,
                total: totalEncontrado,
                assinatura: assinaturaPesquisa,
                pagina: paginaSolicitada,
                tamanho: tamanhoSolicitado,
              });
              setStatusConsulta("awaiting_confirmation");
              setLoadingCard(false);
              return;
            }
            setListaComissoesSelecionadas([]);
            setTotalPages(response.data.totalPages);
            setTotalRegistros(response.data.totalElements);
            await completarListaFatura(response.data.content, nReqAtual);
            if (nReqAtual !== sessionStorage.getItem("nReq")) return;
            setStatusConsulta("success");
            setLoadingCard(false);
          }
        })
        .catch((error) => {
          if (nReqAtual !== sessionStorage.getItem("nReq")) return;
          setLoadingCard(false);
          setStatusConsulta("error");
          setHabilitarPdf(false);
          if (error.response) {
            if (error.response.data && error.response.data.message && error.response.data.message.includes("fromIndex")) {
              setActivePage(1);
            } else {
              Util.tratarErro(error);
            }
          } else {
            Util.notifyError("Ocorreu algum erro inesperado.");
          }
        });
    };

    if (filtroPgCom || filtroStatusAprovacao || filtroAprovadoPor) {
      let promisesIn = [];
      let promisesNotIn = [];

      if (filtroPgCom) {
        let formStatusPgCom = new FormData();
        formStatusPgCom.append("status", filtroPgCom);
        formStatusPgCom.append("chave", CHAVE_WINTHOR_SERVICE);
        promisesIn.push(
          axios.post(URL_CONSULTAR_STATUS_PGCOM, formStatusPgCom).then(res1 => {
            let listaRecnum = res1.data && res1.data.length > 0 ? res1.data.map((f) => f.recnum) : [];
            if (listaRecnum.length === 0) return [];
            let formRecnum = new FormData();
            formRecnum.append("listaRecnum", listaRecnum.join(","));
            return axios.post(URL_OBTER_RELACIONAMENTO_EMLOTE, formRecnum).then(res2 =>
              expandirChavesDesdobradas(
                res2.data.map(f => f.comissaoVenda.numeroTransacaoVenda + "-" + f.comissaoVenda.prestacao)
              )
            );
          })
        );
      }

      if (filtroAprovadoPor) {
        let formAprovadoPor = new FormData();
        formAprovadoPor.append("responsavelAprovacao", filtroAprovadoPor);
        promisesIn.push(
          axios.post(URL_APROVADO_POR, formAprovadoPor).then(res =>
            expandirChavesDesdobradas(res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao))
          )
        );
      }

      if (filtroStatusAprovacao) {
        let formStatusApro = new FormData();
        formStatusApro.append("statusAprovacao", filtroStatusAprovacao);
        if (filtroStatusAprovacao === "Pendente") {
          promisesNotIn.push(
            axios.post(URL_CONSULTAR_STATUS_APRO, formStatusApro).then(res =>
              expandirChavesDesdobradas(res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao))
            )
          );
        } else {
          promisesIn.push(
            axios.post(URL_CONSULTAR_STATUS_APRO, formStatusApro).then(res =>
              expandirChavesDesdobradas(res.data.map(f => f.numeroTransacaoVenda + "-" + f.prestacao))
            )
          );
        }
      }

      Promise.all([...promisesIn, ...promisesNotIn])
        .then(results => {
          let resultsIn = results.slice(0, promisesIn.length);
          let resultsNotIn = results.slice(promisesIn.length);

          let intersectedIn = null;
          if (resultsIn.length > 0) {
            intersectedIn = resultsIn[0];
            for (let i = 1; i < resultsIn.length; i++) {
              intersectedIn = intersectedIn.filter(k => resultsIn[i].includes(k));
            }
            if (intersectedIn.length === 0) {
              if (nReqAtual === sessionStorage.getItem("nReq")) {
                setListaComissoesSelecionadas([]);
                setListaFaturas([]);
                setTotalPages(0);
                setTotalRegistros(0);
                setTotalComissaoBruta(0);
                setLoadingCard(false);
                setStatusConsulta("success");
                setHabilitarPdf(false);
              }
              return;
            }
          }

          let unitedNotIn = null;
          if (resultsNotIn.length > 0) {
            unitedNotIn = [...new Set(resultsNotIn.flat())];
          }

          if (intersectedIn !== null && intersectedIn.length > 0) {
            formData.append("loteTransacaoIn", intersectedIn.join(","));
          }
          if (unitedNotIn !== null && unitedNotIn.length > 0) {
            formData.append("loteTransacaoNotIn", unitedNotIn.join(","));
          }

          executarBuscaWinthor();
        })
        .catch((error) => {
          if (nReqAtual !== sessionStorage.getItem("nReq")) return;
          setLoadingCard(false);
          setStatusConsulta("error");
          setHabilitarPdf(false);
          Util.tratarErro(error);
        });
    } else {
      executarBuscaWinthor();
    }
  }
  function resetarFiltros() {
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    setFiltroFilial([]);
    setFiltroRca([]);
    setFiltroAgenciador([]);
    setFiltroNota("");
    setFiltroTransacao("");
    setFiltroStatusFatura("");
    setFiltroEmissaoInicial("");
    setFiltroEmissaoFinal("");
    setFiltroPgCom("");
    setFiltroAprovadoPor("");
    setFiltroStatusAprovacao("");
    setLoadingCard(false);
    setStatusConsulta("idle");
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "", pagina: 1, tamanho: "10" });
    assinaturaVolumeConfirmadaRef.current = "";
    setActivePage(1);
    limparResultadosPesquisa();
  }

  function cancelarPesquisaVolumosa() {
    sessionStorage.setItem("nReq", parseInt(sessionStorage.getItem("nReq")) + 1);
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "", pagina: 1, tamanho: sizeItensLista });
    setLoadingCard(false);
    setStatusConsulta("idle");
    limparResultadosPesquisa();
  }

  function continuarPesquisaVolumosa() {
    assinaturaVolumeConfirmadaRef.current = confirmacaoVolume.assinatura;
    const paginaConfirmada = confirmacaoVolume.pagina;
    const tamanhoConfirmado = confirmacaoVolume.tamanho;
    setConfirmacaoVolume({ open: false, total: 0, assinatura: "", pagina: 1, tamanho: tamanhoConfirmado });
    filtrarComissoes(false, paginaConfirmada, tamanhoConfirmado);
  }

  function alterarPagina(novaPagina) {
    setActivePage(novaPagina);
    if (statusConsulta === "success") {
      filtrarComissoes(false, novaPagina);
    }
  }

  function alterarTamanhoPagina(novoTamanho) {
    setActivePage(1);
    setSizeItensLista(novoTamanho);
    if (statusConsulta === "success") {
      filtrarComissoes(false, 1, novoTamanho);
    }
  }

  function verificarTransacaoValida(transacao) {
    if (transacao.length >= 6) {
      return true;
    }
    return false;
  }
  
  async function montarPdfGestao(data) {
    const blob = await pdf(<RelatorioPdfGestao data={data} totalComissaoBruta={totalComissaoBruta} />).toBlob();
    let blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
  }

  async function completarListaFatura(listaF, nReqAtual) {
    let totalComissaoB = 0;
    if (listaF.length > 0) {
      let listaFaturasAtualizadas = [...listaF];
      const totalFaturas = listaFaturasAtualizadas.length;

      let loteStr = listaFaturasAtualizadas.map(f => f.numeroTransacaoVenda + "-" + f.prestacao).join(",");
      let formLote = new FormData();
      formLote.append("loteTransacao", loteStr);

      const responseLote = await axios.post(URL_DADOS_VENDA_LOTE, formLote).catch(() => {});
      let mapRes = {};
      if (responseLote && responseLote.data) {
         responseLote.data.forEach(d => mapRes[d.numeroTransacaoVenda + "-" + d.prestacao] = d);
      }

      const faturasParaReconciliar = listaFaturasAtualizadas
        .map(f => ({
          numeroTransacaoVenda: f.numeroTransacaoVenda,
          prestacao: f.prestacao,
        }));

      let mapOrigens = {};
      if (faturasParaReconciliar.length > 0) {
        const responseOrigens = await axios
          .post(URL_ORIGENS_DESDOBRAMENTO + "?chave=" + CHAVE_WINTHOR_SERVICE, faturasParaReconciliar)
          .catch(() => null);

        if (responseOrigens && responseOrigens.data && responseOrigens.data.length > 0) {
          responseOrigens.data.forEach(origem => {
            mapOrigens[origem.numeroTransacaoVenda + "-" + origem.prestacao] = origem;
          });

          const chavesOrigem = [...new Set(responseOrigens.data.map(
            origem => origem.numeroTransacaoVenda + "-" + origem.prestacaoOrigem
          ))];
          const formOrigens = new FormData();
          formOrigens.append("loteTransacao", chavesOrigem.join(","));
          const responseAprovacoesOrigem = await axios.post(URL_DADOS_VENDA_LOTE, formOrigens).catch(() => null);

          if (responseAprovacoesOrigem && responseAprovacoesOrigem.data) {
            responseAprovacoesOrigem.data.forEach(aprovacao => {
              mapRes[aprovacao.numeroTransacaoVenda + "-" + aprovacao.prestacao] = aprovacao;
            });
          }
        }
      }

      if (nReqAtual !== sessionStorage.getItem("nReq")) return;

      for (let i = 0; i < totalFaturas; i++) {
        let faturaAtualizada = { ...listaFaturasAtualizadas[i] };
        const chaveAtual = faturaAtualizada.numeroTransacaoVenda + "-" + faturaAtualizada.prestacao;
        const origem = mapOrigens[chaveAtual];
        let resData = mapRes[chaveAtual];
        if (origem) {
          const chaveOrigem = origem.numeroTransacaoVenda + "-" + origem.prestacaoOrigem;
          const aprovacaoOrigem = mapRes[chaveOrigem];
          if (aprovacaoOrigem && aprovacaoOrigem.aprovada === true) {
            resData = aprovacaoOrigem;
            faturaAtualizada.aprovacaoHerdada = true;
            faturaAtualizada.prestacaoOrigemAprovacao = origem.prestacaoOrigem;
            faturaAtualizada.recnumOrigemAprovacao = origem.recnumOrigem;
          }
        }
        if (resData != undefined) {
          faturaAtualizada.aprovacao = resData.aprovada;
          faturaAtualizada.aprovacaoComercial = resData.aprovacaoComercial;
          faturaAtualizada.aprovacaoFinanceiro = resData.aprovacaoFinanceiro;
          faturaAtualizada.comissaoPagaNoWinthor = resData.comissaoPagaNoWinthor;
          faturaAtualizada.dataAprovacaoComercial = resData.dataAprovacaoComercial;
          faturaAtualizada.dataAprovacaoFinanceiro = resData.dataAprovacaoFinanceiro;
          faturaAtualizada.dataPagamentoComissaoWinthor = resData.dataPagamentoComissaoWinthor;
          faturaAtualizada.motivoRejeicao = resData.motivoRejeicao;
          faturaAtualizada.rejeitada = resData.rejeitada;
          faturaAtualizada.tipoComissao = resData.tipoComissao;
          faturaAtualizada.valorComissaoSelecionada = resData.valorComissaoSelecionada;
          faturaAtualizada.responsavelAprovacaoComercial = resData.responsavelAprovacaoComercial;
          faturaAtualizada.responsavelAprovacaoFinanceiro = resData.responsavelAprovacaoFinanceiro;
          faturaAtualizada.valorAtualizado = resData.valorAtualizado;
        }
        faturaAtualizada.terminouLoading = true;
        listaFaturasAtualizadas[i] = faturaAtualizada;
      }
      
      let currentB = 0;
      listaFaturasAtualizadas.forEach(f => currentB += f.valorComissaoBruta);
      totalComissaoB = currentB;

      if (nReqAtual === sessionStorage.getItem("nReq")) {
        setTotalComissaoBruta(totalComissaoB);
        setListaFaturas(listaFaturasAtualizadas);
        setHabilitarPdf(true);
      }
    } else {
      setHabilitarPdf(false);
      setListaFaturas([]);
      setTotalComissaoBruta(0);
    }
  }

  function isCardSelected(numeroTransacaoVenda, prestacao) {
    return !!listaComissoesSelecionadas.find((fatura) => fatura.numeroTransacaoVenda === numeroTransacaoVenda && fatura.prestacao === prestacao);
  }

  function handleSelecionarTodasDaPagina() {
    const faturasSelecionaveis = listaFaturas.filter(f => {
      if (f.aprovacao === true || f.rejeitada === true || !f.terminouLoading) return false;
      if (usuario.perfil === "Comercial") {
        return !f.aprovacaoComercial;
      } else if (usuario.perfil === "Financeiro") {
        return f.aprovacaoComercial && !f.aprovacaoFinanceiro;
      }
      return false;
    });
    if (faturasSelecionaveis.length === 0) {
      Util.notifyImportant("Não há comissões pendentes de aprovação para o seu perfil nesta página.");
      return;
    }
    if (listaComissoesSelecionadas.length === faturasSelecionaveis.length) {
      setListaComissoesSelecionadas([]);
    } else {
      let novaLista = [];
      faturasSelecionaveis.forEach(f => {
        novaLista.push({
          ...f,
          radioTipoComissao: "",
          radioValorComissao: null,
          radioEstaSelecionada: true,
        });
      });
      setListaComissoesSelecionadas(novaLista);
    }
  }

  function handleChangeComissaoSelecionada(numeroTransacaoVenda, prestacao, tipoComissaoSelecionada, valor, checked, id, nome, fatura) {
    let temComissao = listaComissoesSelecionadas.find((fatura) => fatura.numeroTransacaoVenda === numeroTransacaoVenda && fatura.prestacao === prestacao);
    if (temComissao) {
      if (checked === true) {
        setListaComissoesSelecionadas(
          listaComissoesSelecionadas.map((fatura) => {
            if (fatura.numeroTransacaoVenda === numeroTransacaoVenda && fatura.prestacao === prestacao) {
              return {
                ...fatura,
                radioTipoComissao: tipoComissaoSelecionada,
                radioValorComissao: valor,
                radioEstaSelecionada: true,
              };
            } else {
              return fatura;
            }
          })
        );
      } else {
        setListaComissoesSelecionadas(listaComissoesSelecionadas.filter((fatura) => !(fatura.numeroTransacaoVenda === numeroTransacaoVenda && fatura.prestacao === prestacao)));
      }
    } else {
      if (checked === true) {
        setListaComissoesSelecionadas((prevComissoes) => [
          ...prevComissoes,
          {
            radioTipoComissao: tipoComissaoSelecionada,
            radioValorComissao: valor,
            radioEstaSelecionada: true,
            numeroTransacaoVenda: numeroTransacaoVenda,
            prestacao: prestacao,
            idAgenciador: id,
            nomeAgenciador: fatura ? fatura.nomeAgenciador : "",
            nomeCliente: fatura ? fatura.nomeCliente : "",
            dataVencimento: fatura ? fatura.dataVencimento : "",
            valorComissaoNfe: fatura ? fatura.valorComissaoNfe : "",
            valorComissaoCompraBoleto: fatura ? fatura.valorComissaoCompraBoleto : "",
            valorComissaoSemNfe: fatura ? fatura.valorComissaoSemNfe : "",
            statusFatura: fatura ? fatura.statusFatura : "",
            tipoCobranca: fatura ? fatura.tipoCobranca : "",
          },
        ]);
      }
    }
  }

  function verificarSeComissaoEstaSelecionada(numeroTransacaoVenda, prestacao, tipoComissaoSelecionada, valor, checked) {
    let comissaoSelecionada = listaComissoesSelecionadas.find((fatura) => fatura.numeroTransacaoVenda === numeroTransacaoVenda && fatura.prestacao === prestacao);
    if (comissaoSelecionada) {
      return comissaoSelecionada.radioTipoComissao === tipoComissaoSelecionada ? true : false;
    } else {
      return false;
    }
  }

  function atualizarComissaoAprovada(dados) {
    setListaFaturas(
      listaFaturas.map((fatura) => {
        if (fatura.numeroTransacaoVenda === dados.numeroTransacaoVenda && fatura.prestacao === dados.prestacao) {
          return {
            ...fatura,
            tipoComissao: dados.tipoComissao,
            valorComissaoSelecionada: dados.valorComissaoSelecionada,
            aprovacao: dados.aprovacao,
            aprovacaoComercial: dados.aprovacaoComercial,
            dataAprovacaoComercial: dados.dataAprovacaoComercial,
            responsavelAprovacaoComercial: dados.responsavelAprovacaoComercial,
            aprovacaoFinanceiro: dados.aprovacaoFinanceiro,
            dataAprovacaoFinanceiro: dados.dataAprovacaoFinanceiro,
            responsavelAprovacaoFinanceiro: dados.responsavelAprovacaoFinanceiro,
            comissaoPagaNoWinthor: dados.comissaoPagaNoWinthor,
            dataPagamentoComissaoWinthor: dados.dataPagamentoComissaoWinthor,
            valorAtualizado: dados.valorAtualizado,
            rejeitada: dados.rejeitada,
            motivoRejeicao: dados.motivoRejeicao,
          };
        } else {
          return fatura;
        }
      })
    );
  }

  function handleAprovarComissaoIndividual() {
    setLoadingModal(true);
    let url_aprovacao = faturaModal.radioTipoComissao === "comissao_bruta" ? URL_APROVAR_COMERCIAL : URL_APROVAR_FINANCEIRO;
    let comissao = {
      numeroTransacaoVenda: faturaModal.numeroTransacaoVenda,
      prestacao: faturaModal.prestacao,
      tipoComissao: faturaModal.radioTipoComissao,
      valorComissaoSelecionada: faturaModal.radioValorComissao,
      responsavelAprovacao: usuario.nome,
    };
    if (faturaModal.radioTipoComissao === "comissao_bruta" && formEmailsAprovacao) {
      comissao.emailsAprovacao = formEmailsAprovacao;
      comissao.nomeAgenciador = faturaModal.nomeAgenciador;
      comissao.consumidorFinal = faturaModal.nomeCliente;
      comissao.dataVencimento = faturaModal.dataVencimento ? new Date(faturaModal.dataVencimento).toLocaleDateString("pt-BR") : faturaModal.dataVencimento;
      comissao.valorComNF = faturaModal.valorComissaoNfe;
      comissao.valorCompras = faturaModal.valorComissaoCompraBoleto;
      comissao.valorSemNF = faturaModal.valorComissaoSemNfe;
      comissao.statusParcela = faturaModal.statusFatura;
      comissao.formaPagamento = faturaModal.tipoCobranca;
    }
    axios
      .post(url_aprovacao, comissao)
      .then((response) => {
        atualizarComissaoAprovada(response.data);
        setFormEmailsAprovacao("");
        handleChangeComissaoSelecionada(comissao.numeroTransacaoVenda, comissao.prestacao, comissao.tipoComissao, comissao.valorComissaoSelecionada, false);
        handleCloseModalAprovacao();
        setLoadingModal(false);
        notificarResultadoIntegracao(response.data, "Comissão aprovada com sucesso!");
      })
      .catch((error1) => {
        setLoadingModal(false);
        Util.tratarErro(error1);
      });
  }

  function handleRejeitarComissaoIndividual() {
    setLoadingModal(true);
    let comissao = {
      numeroTransacaoVenda: faturaModal.numeroTransacaoVenda,
      prestacao: faturaModal.prestacao,
      motivoRejeicao: formMotivoRejeicao,
    };
    axios
      .post(URL_REJEITAR, comissao)
      .then((response) => {
        atualizarComissaoAprovada(response.data);
        handleChangeComissaoSelecionada(comissao.numeroTransacaoVenda, comissao.prestacao, "", "", false);
        handleCloseModalRejeicao();
        setFormMotivoRejeicao("");
        setLoadingModal(false);
        Util.notifySuccess("A Comissao foi rejeitada.");
      })
      .catch((error1) => {
        setLoadingModal(false);
        Util.tratarErro(error1);
      });
  }

  async function handleAprovarComissaoMultipla() {
    const comissoesSemTipo = listaComissoesSelecionadas.filter(f => !f.radioTipoComissao);
    if (comissoesSemTipo.length > 0) {
      Util.notifyError("Selecione o tipo de comissão para todas as faturas selecionadas.");
      return;
    }
    setLoadingModal(true);
    for (const [i, fatura] of listaComissoesSelecionadas.entries()) {
      let url_aprovacao = fatura.radioTipoComissao === "comissao_bruta" ? URL_APROVAR_COMERCIAL : URL_APROVAR_FINANCEIRO;
      let comissao = {
        numeroTransacaoVenda: fatura.numeroTransacaoVenda,
        prestacao: fatura.prestacao,
        tipoComissao: fatura.radioTipoComissao,
        valorComissaoSelecionada: fatura.radioValorComissao,
        responsavelAprovacao: usuario.nome,
      };

      try {
        const response = await axios.post(url_aprovacao, comissao);
        notificarResultadoIntegracao(
          response && response.data,
          "Comissão da fatura " + comissao.numeroTransacaoVenda + "-" + comissao.prestacao + " aprovada com sucesso!"
        );
      } catch (error) {
        Util.tratarErro(error);
      }
    }
    setLoadingModal(false);
    handleCloseModalAprovacaoMultipla();
    filtrarComissoes();
  }

  function notificarResultadoIntegracao(resultado, mensagemSucesso) {
    if (resultado && (resultado.statusIntegracao === "ERRO" || resultado.statusIntegracao === "PROCESSANDO")) {
      Util.notifyImportant(resultado.mensagemIntegracao || "A aprovação foi salva e a integração com o WinThor continua em processamento.");
      return;
    }
    Util.notifySuccess(mensagemSucesso);
  }

  async function handleRejeitarComissaoMultipla() {
    setLoadingModal(true);
    for (const [i, fatura] of listaComissoesSelecionadas.entries()) {
      let comissao = {
        numeroTransacaoVenda: fatura.numeroTransacaoVenda,
        prestacao: fatura.prestacao,
        motivoRejeicao: formMotivoRejeicao,
      };

      try {
        await axios.post(URL_REJEITAR, comissao);
        Util.notifySuccess("Comissao da fatura " + comissao.numeroTransacaoVenda + "-" + comissao.prestacao + " foi rejeitada.");
      } catch (error) {
        Util.tratarErro(error);
      }
    }
    filtrarComissoes();
    setLoadingModal(false);
    handleCloseModalRejeicaoMultipla();
    setFormMotivoRejeicao("");
  }

  function handleOpenModalAprovacao(fatura) {
    let temComissao = listaComissoesSelecionadas.find((f) => f.numeroTransacaoVenda === fatura.numeroTransacaoVenda && f.prestacao === fatura.prestacao);
    if (temComissao && temComissao.radioTipoComissao) {
      setFaturaModal(temComissao);
      setFormEmailsAprovacao(fatura.emailAgenciador);
      setOpenModalAprovacao(true);
    } else {
      Util.notifyError("Por favor, selecione um tipo de comissão.");
    }
  }
  function handleCloseModalAprovacao() {
    setOpenModalAprovacao(false);
    setFormEmailsAprovacao("");
    setFaturaModal(null);
  }

  function handleOpenModalRejeicao(fatura) {
    setFaturaModal(fatura);
    setOpenModalRejeicao(true);
  }

  function handleCloseModalRejeicao() {
    setOpenModalRejeicao(false);
    setFormMotivoRejeicao("");
    setFaturaModal(null);
  }

  function handleOpenModalAprovacaoMultipla() {
    if (listaComissoesSelecionadas.length > 0) {
      const comissoesSemTipo = listaComissoesSelecionadas.filter(f => !f.radioTipoComissao);
      if (comissoesSemTipo.length > 0) {
        Util.notifyError("Selecione o tipo de comissão para todas as faturas antes de aprovar.");
        return;
      }
      setOpenModalAprovacaoMultipla(true);
    } else {
      Util.notify("Selecione um tipo de comissao.");
    }
  }
  function handleCloseModalAprovacaoMultipla() {
    setOpenModalAprovacaoMultipla(false);
  }

  function handleOpenModalRejeicaoMultipla() {
    if (listaComissoesSelecionadas.length > 0) {
      setOpenModalRejeicaoMultipla(true);
    } else {
      Util.notify("Selecione um tipo de comissao.");
    }
  }

  function handleCloseModalRejeicaoMultipla() {
    setOpenModalRejeicaoMultipla(false);
    setFormMotivoRejeicao("");
  }

  return (
    <div>
      <MenuSistema openModal={openModalAprovacao || openModalAprovacaoMultipla || openModalRejeicao || openModalRejeicaoMultipla || confirmacaoVolume.open} perfil={usuario.perfil} nome={usuario.nome} />
      <Modal
        size="tiny"
        centered
        open={confirmacaoVolume.open}
        closeOnDimmerClick={false}
        closeOnEscape={false}
      >
        <Modal.Header style={{ color: "#2a5faa" }}>
          <Icon name="warning sign" color="orange" />
          Pesquisa com muitos resultados
        </Modal.Header>
        <Modal.Content>
          <p style={{ fontSize: "1.1rem", lineHeight: 1.6 }}>
            Esta pesquisa encontrou <strong>{confirmacaoVolume.total.toLocaleString("pt-BR")} registros</strong>.
            Embora a listagem seja paginada, a consulta pode levar mais tempo que o normal. Deseja continuar?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" icon="filter" content="Revisar filtros" onClick={cancelarPesquisaVolumosa} />
          <Button color="blue" icon="check" content="Continuar pesquisa" onClick={continuarPesquisaVolumosa} />
        </Modal.Actions>
      </Modal>
      <Container fluid style={{ padding: "0" }}>
        <Header as="h2" textAlign="center" color="grey" className="page-header">
          Gestao de Comissoes
        </Header>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
            <Button 
              color={menuFiltro ? "blue" : "grey"}
              basic={!menuFiltro}
              onClick={() => setMenuFiltro(!menuFiltro)}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <Icon name="filter" style={{ margin: 0 }} />
              Filtros
              <Icon name={menuFiltro ? "chevron up" : "chevron down"} style={{ margin: 0 }} />
            </Button>


            <Button
              icon
              labelPosition="left"
              color="red"
              disabled={!habilitarPdf || !listaFaturas || listaFaturas.length === 0}
              title="Clique aqui para gerar um relatorio no formato PDF"
              style={{ marginLeft: "1rem" }}
              onClick={() => montarPdfGestao(listaFaturas)}
            >
              <Icon name="file pdf" />
              Gerar PDF
            </Button>
          </div>
          {statusConsulta === "success" && totalPages > 0 && <Pagination
            boundaryRange={window.innerWidth <= 770 ? 0 : 1}
            siblingRange={window.innerWidth <= 770 ? 0 : 1}
            activePage={activePage}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={totalPages}
            onPageChange={(e, { activePage }) => alterarPagina(activePage)}
          />}
        </div>
        {menuFiltro && (
          <Segment
            attached="bottom"
            className="filtro filtro-header"
            style={{
              zIndex: openModalAprovacao || openModalAprovacaoMultipla || openModalRejeicao || openModalRejeicaoMultipla || confirmacaoVolume.open ? "900" : "1002",
            }}
          >
            {/* <Header as='h2' textAlign="left" color="grey" className="filtro-header" >Filtros</Header> */}
            <Form size="tiny" className="form-filtros">
              <Message info size="tiny" icon style={{ marginTop: 0 }}>
                <Icon name="info circle" />
                <Message.Content>
                  Informe o período completo ou pelo menos um destes filtros: Número da Nota, RCA ou Agenciador.
                </Message.Content>
              </Message>
              <Form.Group style={{ position: 'relative', zIndex: 110 }}>
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="Filial"
                  disabled={false}
                  placeholder="Filtrar por Filial"
                  options={listaFiliais}
                  value={filtroFilial}
                  onChange={(e, { value }) => setFiltroFilial(value)}
                  width={5}
                />
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="RCA"
                  disabled={false}
                  placeholder="Filtrar por RCA"
                  options={listaRCA}
                  value={filtroRca}
                  onChange={(e, { value }) => setFiltroRca(value)}
                  width={5}
                />
                <Form.Select
                  fluid
                  search
                  multiple
                  selection
                  clearable
                  label="Agenciador"
                  placeholder="Filtrar por Agenciador"
                  disabled={false}
                  options={listaAgenciadores}
                  value={filtroAgenciador}
                  onChange={(e, { value }) => setFiltroAgenciador(value)}
                  width={6}
                />
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 109 }}>
                <Form.Input
                  fluid
                  label="Nº Nota"
                  placeholder="Filtrar por Nº Nota"
                  disabled={false}
                  value={filtroNota}
                  onChange={(e, { value }) => setFiltroNota(value)}
                  width={3}
                />
                <Form.Input
                  fluid
                  label="Transação"
                  placeholder="Filtrar por Transação"
                  disabled={false}
                  value={filtroTransacao}
                  onChange={(e, { value }) => setFiltroTransacao(value)}
                  width={3}
                />
                <Form.Select
                  fluid
                  search
                  label="Status Fatura"
                  placeholder="Filtrar por Status da Fatura"
                  disabled={false}
                  options={listaStatusFatura}
                  value={filtroStatusFatura}
                  onChange={(e, { value }) => setFiltroStatusFatura(value)}
                  width={10}
                />
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 108 }}>
                <Form.Field className="datepicker-field" disabled={false} width={3}>
                  <label>Data Emissão Inicial</label>
                  <div className="datepicker-input">
                    <SemanticDatepicker
                      locale="pt-BR"
                      disabled={false}
                      format="DD/MM/YYYY"
                      value={filtroEmissaoInicial}
                      onChange={(e, { value }) => { 
                        setFiltroEmissaoInicial(value);
                        if (e && e.type) setTextoAtalhoPeriodo('Atalhos de Período'); 
                      }}
                    />
                  </div>
                </Form.Field>
                <Form.Field className="datepicker-field" disabled={false} width={3}>
                  <label>Data Emissão Final</label>
                  <div className="datepicker-input">
                    <SemanticDatepicker
                      locale="pt-BR"
                      disabled={false}
                      format="DD/MM/YYYY"
                      value={filtroEmissaoFinal}
                      onChange={(e, { value }) => { 
                        setFiltroEmissaoFinal(value);
                        if (e && e.type) setTextoAtalhoPeriodo('Atalhos de Período'); 
                      }}
                    />
                  </div>
                </Form.Field>
                <Form.Field width={3}>
                  <label>&nbsp;</label>
                  <Dropdown text={textoAtalhoPeriodo} button className='icon' disabled={false} fluid>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('hoje')} text='Hoje' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('semana')} text='Esta Semana' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('mes')} text='Este Mês' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('mes_passado')} text='Mês Passado' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('3_meses')} text='Últimos 3 Meses' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('6_meses')} text='Últimos 6 Meses' />
                      <Dropdown.Item onClick={() => aplicarPeriodoRapido('1_ano')} text='Último 1 Ano' />
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Field>
                <Form.Field width={4}>
                  <label>&nbsp;</label>
                  <Button
                    color="blue"
                    icon="search"
                    content="Pesquisar"
                    disabled={loadingCard}
                    onClick={() => {
                      setActivePage(1);
                      filtrarComissoes(true, 1);
                    }}
                    fluid
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group style={{ position: 'relative', zIndex: 107 }}>
                <Form.Select
                  fluid
                  search
                  label="Pg Com"
                  placeholder="Filtrar por Pg Com"
                  disabled={false}
                  options={selectPgCom}
                  value={filtroPgCom}
                  onChange={(e, { value }) => setFiltroPgCom(value)}
                  width={4}
                />
                <Form.Select
                  fluid
                  search
                  label="Status da Aprovacao"
                  placeholder="Filtrar por Status da Aprovacao"
                  disabled={false}
                  options={selectStatusApro}
                  value={filtroStatusAprovacao}
                  onChange={(e, { value }) => setFiltroStatusAprovacao(value)}
                  width={4}
                />
                <Form.Select
                  fluid
                  search
                  label="Aprovado Por"
                  placeholder="Filtrar por quem aprovou a comissao"
                  disabled={false}
                  options={listaAprovadores}
                  value={filtroAprovadoPor}
                  onChange={(e, { value }) => setFiltroAprovadoPor(value)}
                  width={4}
                />
                <Button
                  style={{ alignSelf: "end", marginLeft: ".2rem", padding: "10px 15px" }}
                  type="button"
                  color="grey"
                  basic
                  icon="eraser"
                  content="Limpar Todos os Filtros"
                  title="Clique aqui para limpar os campos de filtragem"
                  onClick={() => resetarFiltros()}
                />
              </Form.Group>
            </Form>
          </Segment>
        )}
        <style>{`
          @keyframes modalPopIn {
            0% { transform: scale(0.8); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .modern-blue-modal {
            background: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%);
            border-radius: 20px;
            padding: 40px 60px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            animation: modalPopIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            color: white;
          }
        `}</style>
        <Dimmer.Dimmable dimmed={loadingCard}>
          <Dimmer active={loadingCard} page style={{backgroundColor: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(5px)", zIndex: 999999}}>
            <div className="modern-blue-modal">
               <Icon name="circle notch" loading size="huge" style={{marginBottom: '15px'}} />
               <Header as="h2" style={{color: 'white', marginTop: '0', fontWeight: '600', letterSpacing: '1px'}}>
                  Buscando informações
               </Header>
               <p style={{color: 'rgba(255,255,255,0.85)', fontSize: '1.1rem', margin: '0'}}>
                  {progressoLoading === 100 
                ? "Finalizando o processamento... (100%)" 
                : progressoLoading >= 99 
                  ? "Por favor, aguarde, finalizando o processamento... (99%)"
                  : `Por favor, aguarde enquanto buscamos os dados... (${progressoLoading}%)`}
               </p>
            </div>
          </Dimmer>
          <Segment>
            {statusConsulta === "success" && listaFaturas.length === 0 && !loadingCard && (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <Message warning icon size="massive" style={{ textAlign: 'center', maxWidth: '800px' }}>
                  <Icon name='search' />
                  <Message.Content>
                    <Message.Header style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Nenhuma informação encontrada</Message.Header>
                    <p style={{ fontSize: '1.2rem' }}>Não existem comissões para o filtro e período selecionado.</p>
                  </Message.Content>
                </Message>
              </div>
            )}
            {listaFaturas.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '1rem', marginBottom: '1rem', borderBottom: '1px solid #eee', paddingBottom: '1rem' }}>
                <Button 
                  icon 
                  labelPosition='left' 
                  color={listaComissoesSelecionadas.length > 0 ? "blue" : "grey"}
                  basic={listaComissoesSelecionadas.length === 0}
                  onClick={() => handleSelecionarTodasDaPagina()}
                  style={{ margin: 0 }}
                >
                  <Icon name={listaComissoesSelecionadas.length > 0 ? "check square" : "square outline"} />
                  Selecionar Todas da Página
                </Button>
                <Dropdown
                  style={{ minWidth: "180px" }}
                  options={qtdItensLista}
                  selection
                  value={sizeItensLista}
                  onChange={(e, { value }) => alterarTamanhoPagina(value)}
                />

                {listaComissoesSelecionadas.length > 0 && (
                  <div style={{ marginLeft: "auto", display: "flex", gap: "1rem" }}>
                    <Button icon labelPosition="left" color="red" onClick={() => handleOpenModalRejeicaoMultipla()}>
                      <Icon name="times" />
                      Rejeitar ({listaComissoesSelecionadas.length})
                    </Button>
                    <Button icon labelPosition="left" color="blue" onClick={() => handleOpenModalAprovacaoMultipla()}>
                      <Icon name="check" />
                      Aprovar ({listaComissoesSelecionadas.length})
                    </Button>
                  </div>
                )}
              </div>
            )}
            {listaFaturas.map((fatura) => {
              return (
                <Card 
                  fluid 
                  color="blue" 
                  key={fatura.numeroTransacaoVenda + fatura.prestacao}
                  style={isCardSelected(fatura.numeroTransacaoVenda, fatura.prestacao) ? {
                    boxShadow: '0 0 0 2px #2185d0, 0 8px 24px rgba(33, 133, 208, 0.2)',
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  } : { transition: 'all 0.3s ease' }}
                >
                  <Card.Content className="fatura__card__header" style={{ paddingBottom: ".3rem", paddingTop: "1rem" }}>
                    <Card.Header style={{display: 'flex', alignItems: 'center'}}>
                      {!(fatura.aprovacao === true || fatura.rejeitada === true || !fatura.terminouLoading) && (
                        <Form.Checkbox
                          checked={isCardSelected(fatura.numeroTransacaoVenda, fatura.prestacao)}
                          onChange={(e, { checked }) => handleChangeComissaoSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "", null, checked, fatura.idAgenciador, fatura.nomeAgenciador, fatura)}
                          style={{ marginRight: '10px' }}
                        />
                      )}
                      Agenciador: {fatura.nomeAgenciador}
                    </Card.Header>
                    {fatura.statusFatura === "Quitada" && <Label color="green" ribbon="right">{fatura.statusFatura}</Label>}
                    {fatura.statusFatura === "A Vencer" && <Label color="yellow" ribbon="right">{fatura.statusFatura}</Label>}
                    {fatura.statusFatura === "Vencida" && <Label color="red" ribbon="right">{fatura.statusFatura}</Label>}
                  </Card.Content>
                  <Card.Content>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: ".5rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          marginBottom: ".5rem",
                          gap: ".5rem",
                          justifyContent: "space-between",
                          padding: ".1rem 1rem",
                        }}
                      >
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>
                            <b>Cliente: &nbsp; {fatura.nomeCliente}</b>
                          </span>
                          <span>Emissao: &nbsp; {Util.exibirDataFormatada(fatura.dataEmissao)}</span>
                          <span>Quitacao: &nbsp; {Util.exibirDataFormatada(fatura.dataQuitacao)}</span>
                          <span>Vencimento: &nbsp; {Util.exibirDataFormatada(fatura.dataVencimento)}</span>
                          <span>
                            Transacao: <b>{fatura.numeroTransacaoVenda + "-" + fatura.prestacao}</b>
                          </span>
                          <span>
                            Regiao do pedido: &nbsp; <b>{fatura.regiaoPedido}</b>{" "}
                          </span>
                        </div>
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>
                            Cobranca: &nbsp; <b>{fatura.tipoCobranca}</b>
                          </span>
                          <span>Cod. Profissional: &nbsp; {fatura.codigoProfissional}</span>
                          <span>Cod. Vendedor: &nbsp; {fatura.idRCA}</span>
                          <span>Dt. Devol: &nbsp; {Util.exibirDataFormatada(fatura.dataDevolucao)}</span>
                          <span>Vl. Devol: &nbsp; {fatura.dataDevolucao ? Util.exibirValorMonetarioBr(fatura.valorDevolvido) : ""}</span>
                        </div>
                        <div className="fatura__card__column" style={{ display: "flex", flexDirection: "column" }}>
                          <span>Vl. Vendido: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorVenvido)}</span>
                          <span>Vl. Tabela PSD: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorTabelaPSD)}</span>
                          <span>Percentual: &nbsp; {fatura.percentual + "%"}</span>
                          <span>Nota: &nbsp; {fatura.numeroNota}</span>
                          <span>Parcela: &nbsp; {fatura.prestacao}</span>
                          <span>Vl. Parcela: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorParcela)}</span>
                        </div>
                        <Dimmer.Dimmable style={{ width: "25%" }} className="fatura_card_column--radio" dimmed={!fatura.terminouLoading}>
                          <Dimmer active={!fatura.terminouLoading} inverted>
                            <Loader active={!fatura.terminouLoading} />
                          </Dimmer>
                          <div
                            className="fatura__card__column fatura_card_column--radio"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            {fatura.rejeitada === true ? (
                              <span style={{ fontWeight: "bold" }}>
                                Status da aprovacao: &nbsp; <b style={{ color: "red" }}>{"Rejeitada"}</b>
                              </span>
                            ) : (
                              <span style={{ fontWeight: "bold" }}>
                                Status da aprovacao: &nbsp;{" "}
                                <b
                                  style={{
                                    color: fatura.aprovacao ? "royalblue" : "gold",
                                  }}
                                >
                                  {fatura.aprovacao ? "Aprovada" : "Pendente"}
                                </b>
                              </span>
                            )}
                            {fatura.rejeitada === true && <span style={{ fontWeight: "bold" }}>Motivo rejeicao: &nbsp; {fatura.motivoRejeicao}</span>}
                            {fatura.aprovacao === true && (
                              <>
                                {fatura.aprovacaoHerdada === true && (
                                  <Message info size="small">
                                    Aprovação mantida após desdobramento da parcela {fatura.prestacaoOrigemAprovacao}
                                    {fatura.recnumOrigemAprovacao ? " (lançamento " + fatura.recnumOrigemAprovacao + ")" : ""}.
                                  </Message>
                                )}
                                <span>
                                  <b>Tipo Comissao: &nbsp; {fatura.tipoComissao ? fatura.tipoComissao.replace(/_/g, " ").replace("c", "C") : ""}</b>
                                </span>
                                <span>
                                  <b>Vl. Comissao: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorComissaoSelecionada)}</b>
                                </span>
                                <br />
                                {fatura.tipoComissao !== "comissao_bruta" && (
                                  <span style={{ opacity: ".45" }}>
                                    <b>Comissao bruta: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}</b>
                                  </span>
                                )}
                                {fatura.tipoComissao !== "comissao_com_nfe" && (
                                  <span style={{ opacity: ".45" }}>
                                    <b>Comissao com nfe: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}</b>
                                  </span>
                                )}
                                {fatura.tipoComissao !== "comissao_sem_nfe" && (
                                  <span style={{ opacity: ".45" }}>
                                    <b>Comissao sem nfe: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorComissaoSemNfe)}</b>
                                  </span>
                                )}
                                {fatura.tipoComissao !== "comissao_compra_boleto" && (
                                  <span style={{ opacity: ".45" }}>
                                    <b>Comissao compra/boleto: &nbsp; {Util.exibirValorMonetarioBr(fatura.valorComissaoCompraBoleto)}</b>
                                  </span>
                                )}
                              </>
                            )}
                            {!(fatura.aprovacao === true || fatura.rejeitada === true || !fatura.terminouLoading) && (
                              <Form className="fatura__card__radio">
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      textAlign: "right",
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao bruta:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_bruta"
                                    disabled={fatura.aprovacaoComercial || usuario.perfil !== "Comercial"}
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_bruta", fatura.valorComissaoBruta)}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_bruta",
                                        fatura.valorComissaoBruta,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoBruta)}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao nfe representacoes:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_nfe_representacoes"
                                    disabled={!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro"}
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_nfe_representacoes", fatura.valorComissaoNfeRepresentacoes)}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_nfe_representacoes",
                                        fatura.valorComissaoNfeRepresentacoes,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoNfeRepresentacoes)}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao nfe solar:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_nfe_solar"
                                    disabled={!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro"}
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_nfe_solar", fatura.valorComissaoNfeSolar)}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_nfe_solar",
                                        fatura.valorComissaoNfeSolar,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoNfeSolar)}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      textAlign: "right",
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao com nfe:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_com_nfe"
                                    disabled={!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro"}
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_com_nfe", fatura.valorComissaoBruta)}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_com_nfe",
                                        fatura.valorComissaoNfe,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoNfe)}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      textAlign: "right",
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao sem nfe:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_sem_nfe"
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_sem_nfe", fatura.valorComissaoBruta)}
                                    disabled={!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro"}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_sem_nfe",
                                        fatura.valorComissaoSemNfe,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoSemNfe)}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    justifyContent: "normal",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <span
                                    style={{
                                      textAlign: "right",
                                      width: "15rem",
                                    }}
                                  >
                                    <b>Comissao compra/boleto:</b>
                                  </span>
                                  <Form.Radio
                                    value="comissao_compra_boleto"
                                    checked={verificarSeComissaoEstaSelecionada(fatura.numeroTransacaoVenda, fatura.prestacao, "comissao_compra_boleto", fatura.valorComissaoBruta)}
                                    disabled={!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro"}
                                    onClick={(e, { checked }) =>
                                      handleChangeComissaoSelecionada(
                                        fatura.numeroTransacaoVenda,
                                        fatura.prestacao,
                                        "comissao_compra_boleto",
                                        fatura.valorComissaoCompraBoleto,
                                        checked,
                                        fatura.idAgenciador,
                                        fatura.nomeAgenciador,
                                        fatura
                                      )
                                    }
                                    label={Util.exibirValorMonetarioBr(fatura.valorComissaoCompraBoleto)}
                                  />
                                </div>
                              </Form>
                            )}
                          </div>
                        </Dimmer.Dimmable>
                      </div>
                      <Dimmer.Dimmable dimmed={!fatura.terminouLoading}>
                        <Dimmer active={!fatura.terminouLoading} inverted>
                          <Loader active={!fatura.terminouLoading} />
                        </Dimmer>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: "2rem",
                          }}
                        >
                          {fatura.aprovacaoComercial === true && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                              }}
                            >
                              <span>
                                Aprovada no Comercial: &nbsp;
                                <b>{fatura.responsavelAprovacaoComercial}</b>
                              </span>
                              <span>
                                Data da Aprovacao: &nbsp;
                                <b>{Util.exibirDataFormatada(fatura.dataAprovacaoComercial + " 00:00:00.0")}</b>
                              </span>
                            </div>
                          )}
                          {fatura.aprovacaoFinanceiro === true && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                              }}
                            >
                              <span>
                                Aprovada no Financeiro: &nbsp;
                                <b>{fatura.responsavelAprovacaoFinanceiro}</b>
                              </span>
                              <span>
                                Data da Aprovacao: &nbsp;
                                <b>{Util.exibirDataFormatada(fatura.dataAprovacaoFinanceiro + " 00:00:00.0")}</b>
                              </span>
                            </div>
                          )}
                        </div>
                      </Dimmer.Dimmable>
                    </div>
                  </Card.Content>
                  {!(fatura.aprovacao === true || fatura.rejeitada === true || !fatura.terminouLoading) && !(fatura.aprovacaoComercial || usuario.perfil !== "Comercial") && (
                    <Card.Content style={{ paddingBottom: ".6rem", paddingTop: ".4rem" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button color="red" size="tiny" onClick={() => handleOpenModalRejeicao(fatura)}>
                          Rejeitar Comissao
                        </Button>
                        <Button color="blue" size="tiny" onClick={() => handleOpenModalAprovacao(fatura)}>
                          Aprovar Comissao
                        </Button>
                      </div>
                    </Card.Content>
                  )}
                  {!(fatura.aprovacao === true || fatura.rejeitada === true || !fatura.terminouLoading) &&
                    !(!fatura.aprovacaoComercial || fatura.aprovacaoFinanceiro || usuario.perfil !== "Financeiro") && (
                      <Card.Content style={{ paddingBottom: ".6rem", paddingTop: ".4rem" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                          }}
                        >
                          <Button color="red" size="tiny" onClick={() => handleOpenModalRejeicao(fatura)}>
                            Rejeitar Comissao
                          </Button>
                          <Button color="blue" size="tiny" onClick={() => handleOpenModalAprovacao(fatura)}>
                            Aprovar Comissao
                          </Button>
                        </div>
                      </Card.Content>
                    )}
                </Card>
              );
            })}
            {listaFaturas.length > 0 && <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <p
                style={{
                  textAlign: "right",
                  fontSize: "1.3rem",
                  padding: "3px",
                }}
              >
                <b>{"Total comissao bruta: " + Util.exibirValorMonetarioBr(totalComissaoBruta)}</b>
              </p>
            </div>}
          </Segment>
        </Dimmer.Dimmable>
        {statusConsulta === "success" && listaFaturas.length > 0 && <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            paddingBottom: "5rem",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <p style={{ textAlign: "right", fontSize: "1.2rem" }}>
              <b>{totalRegistros} registros listados</b>
            </p>
          </div>
          <Pagination
            boundaryRange={window.innerWidth <= 770 ? 0 : 1}
            siblingRange={window.innerWidth <= 770 ? 0 : 1}
            activePage={activePage}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={totalPages}
            onPageChange={(e, { activePage }) => alterarPagina(activePage)}
          />
        </div>}


      </Container>

      <Modal size="tiny" centered closeIcon={false} closeOnDimmerClick={loadingModal ? false : true} open={openModalAprovacao} onClose={() => handleCloseModalAprovacao()}>
        {faturaModal && openModalAprovacao && (
          <>
            <Modal.Header
              style={{
                textAlign: "center",
                backgroundColor: loadingModal ? "lightblue" : "dodgerblue",
                color: loadingModal ? "darkgrey" : "black",
              }}
            >
              Deseja Aprovar esta comissao?
            </Modal.Header>
            <Modal.Content style={{ textAlign: "center", fontSize: "1.5rem" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted>
                  <Loader active={loadingModal}></Loader>
                </Dimmer>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <span>{faturaModal.radioTipoComissao.replace(/_/g, " ").replace("c", "C") + ":"}</span>
                  <span>
                    <b>{Util.exibirValorMonetarioBr(faturaModal.radioValorComissao)}</b>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <span>Agenciador:</span>
                  <span>
                    <b>{faturaModal.idAgenciador + " - " + faturaModal.nomeAgenciador}</b>
                  </span>
                </div>
              </Dimmer.Dimmable>
            </Modal.Content>
            <Modal.Actions style={{ textAlign: "center" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted></Dimmer>
                <Form style={{ marginTop: "1rem", marginBottom: "2rem" }}>
                  {faturaModal.radioTipoComissao === "comissao_bruta" && (
                    <Form.Input
                      type="email"
                      placeholder="Digite o Email"
                      style={{ textAlign: "left", marginTop: "1rem" }}
                      label="Enviar notificacao por Email para o Agenciador? (Opcional)"
                      value={formEmailsAprovacao}
                      onChange={(e) => setFormEmailsAprovacao(e.target.value)}
                    />
                  )}
                </Form>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button onClick={() => handleCloseModalAprovacao()}>Nao</Button>
                  <Button color="blue" onClick={() => handleAprovarComissaoIndividual()}>
                    Aprovar Comissao
                  </Button>
                </div>
              </Dimmer.Dimmable>
            </Modal.Actions>
          </>
        )}
      </Modal>
      <Modal size="tiny" centered closeIcon={false} closeOnDimmerClick={loadingModal ? false : true} open={openModalRejeicao} onClose={() => handleCloseModalRejeicao()}>
        {faturaModal && openModalRejeicao && (
          <>
            <Modal.Header
              style={{
                textAlign: "center",
                backgroundColor: loadingModal ? "rgba(300,0,0,0.5)" : "indianred",
                color: loadingModal ? "darkgrey" : "black",
              }}
            >
              Deseja Rejeitar esta comissao?
            </Modal.Header>
            <Modal.Content style={{ textAlign: "center", fontSize: "1.5rem" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted>
                  <Loader active={loadingModal}></Loader>
                </Dimmer>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <span>Transacao:</span>
                  <span>
                    <b>{faturaModal.numeroTransacaoVenda + "-" + faturaModal.prestacao}</b>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <span>Agenciador:</span>
                  <span>
                    <b>{faturaModal.idAgenciador + " - " + faturaModal.nomeAgenciador}</b>
                  </span>
                </div>
              </Dimmer.Dimmable>
            </Modal.Content>
            <Modal.Actions style={{ textAlign: "center" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted></Dimmer>
                <Form style={{ marginTop: "1rem", marginBottom: "2rem" }}>
                  <Form.TextArea
                    style={{ textAlign: "left" }}
                    placeholder="Digite aqui o motivo da rejeicao"
                    label="Informe o motivo da rejeicao"
                    onChange={(e) => setFormMotivoRejeicao(e.target.value)}
                  />
                </Form>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button onClick={() => handleCloseModalRejeicao()}>Nao</Button>
                  <Button negative onClick={() => handleRejeitarComissaoIndividual()}>
                    Rejeitar Comissao
                  </Button>
                </div>
              </Dimmer.Dimmable>
            </Modal.Actions>
          </>
        )}
      </Modal>
      <Modal
        size="small"
        centered
        closeIcon={false}
        closeOnDimmerClick={loadingModal ? false : true}
        open={openModalAprovacaoMultipla}
        onClose={() => handleCloseModalAprovacaoMultipla()}
      >
        {listaComissoesSelecionadas.length > 0 && (
          <>
            <Modal.Header
              style={{
                backgroundColor: "dodgerblue",
                textAlign: "center",
                backgroundColor: loadingModal ? "lightblue" : "dodgerblue",
                color: loadingModal ? "darkgrey" : "black",
              }}
            >
              Deseja Aprovar estas comissoes?
            </Modal.Header>
            <Modal.Content style={{ fontSize: "1.1rem" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted>
                  <Loader active={loadingModal} />
                </Dimmer>
                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Agenciador</Table.HeaderCell>
                      <Table.HeaderCell>Transacao</Table.HeaderCell>
                      <Table.HeaderCell>Comissao</Table.HeaderCell>
                      <Table.HeaderCell>Valor</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {listaComissoesSelecionadas.map((fatura) => (
                      <Table.Row>
                        <Table.Cell>{fatura.idAgenciador + " - " + fatura.nomeAgenciador}</Table.Cell>
                        <Table.Cell>{fatura.numeroTransacaoVenda + "-" + fatura.prestacao}</Table.Cell>
                        <Table.Cell>{fatura.radioTipoComissao}</Table.Cell>
                        <Table.Cell textAlign="right">{Util.exibirValorMonetarioBr(fatura.radioValorComissao)}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Dimmer.Dimmable>
            </Modal.Content>
            <Modal.Actions style={{ textAlign: "center" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted></Dimmer>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button onClick={() => handleCloseModalAprovacaoMultipla()}>Nao</Button>
                  <Button color="blue" onClick={() => handleAprovarComissaoMultipla()}>
                    Aprovar Comissoes
                  </Button>
                </div>
              </Dimmer.Dimmable>
            </Modal.Actions>
          </>
        )}
      </Modal>
      <Modal
        size="small"
        centered
        closeIcon={false}
        closeOnDimmerClick={loadingModal ? false : true}
        open={openModalRejeicaoMultipla}
        onClose={() => handleCloseModalRejeicaoMultipla()}
      >
        {listaComissoesSelecionadas.length > 0 && (
          <>
            <Modal.Header
              style={{
                textAlign: "center",
                backgroundColor: loadingModal ? "rgba(300,0,0,0.5)" : "indianred",
                color: loadingModal ? "darkgrey" : "black",
              }}
            >
              Deseja Rejeitar estas comissoes?
            </Modal.Header>
            <Modal.Content style={{ fontSize: "1.1rem" }}>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted>
                  <Loader active={loadingModal} />
                </Dimmer>
                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Agenciador</Table.HeaderCell>
                      <Table.HeaderCell>Transacao</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {listaComissoesSelecionadas.map((fatura) => (
                      <Table.Row>
                        <Table.Cell>{fatura.idAgenciador + " - " + fatura.nomeAgenciador}</Table.Cell>
                        <Table.Cell>{fatura.numeroTransacaoVenda + "-" + fatura.prestacao}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Dimmer.Dimmable>
            </Modal.Content>
            <Modal.Actions>
              <Dimmer.Dimmable dimmed={loadingModal}>
                <Dimmer active={loadingModal} inverted></Dimmer>
                <Form style={{ marginTop: "1rem", marginBottom: "2rem" }}>
                  <Form.TextArea
                    style={{ textAlign: "left" }}
                    placeholder="Digite aqui o motivo da rejeicao dessas comissoes"
                    label="Informe o motivo das rejeicoes"
                    onChange={(e) => setFormMotivoRejeicao(e.target.value)}
                  />
                </Form>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button onClick={() => handleCloseModalRejeicaoMultipla()}>Nao</Button>
                  <Button negative onClick={() => handleRejeitarComissaoMultipla()}>
                    Rejeitar Comissoes
                  </Button>
                </div>
              </Dimmer.Dimmable>
            </Modal.Actions>
          </>
        )}
      </Modal>
    </div>
  );
}
